import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { NavLink } from '../NavLink';
import Grid from '@mui/material/Grid';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function IngramAppStore(props) {
  var appStore = props.appStore;
  var navItems = useMemo(function () {
    return appStore ? appStore.map(function (store) {
      return {
        content: /*#__PURE__*/_jsx("img", {
          alt: store.name,
          src: typeof store.iconImage === 'string' ? store.iconImage : ''
        }),
        key: store.name,
        label: store.name,
        url: store.url
      };
    }) : [];
  }, [appStore]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: navItems.length ? /*#__PURE__*/_jsxs(Grid, {
      alignItems: "center",
      container: true,
      gap: '16px',
      justifyContent: "start",
      marginBottom: 5,
      marginTop: 4,
      children: [/*#__PURE__*/_jsx(StyledStack, {
        children: navItems.map(function (navItem) {
          return /*#__PURE__*/_jsx(StyledNavLink, {
            "data-testid": navItem.key,
            navItem: navItem
          }, navItem.key);
        })
      }), /*#__PURE__*/_jsx("img", {
        alt: "App Download QR Code",
        height: "95px",
        src: "/cep/assets/img/app-download-qr-code.png",
        style: {
          borderRadius: '6px',
          boxShadow: '0px 2px 7px 0px #00000040',
          padding: '3px'
        },
        width: "95px"
      })]
    }) : null
  });
}
var StyledNavLink = styled(NavLink)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& img': {
      display: 'block',
      width: '133px'
    },
    '@media only screen and (max-width: 1023.9px)': {
      margin: '0 13px 0 0 !important'
    },
    display: 'inline-block',
    height: 40
  };
});
var StyledStack = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    '@media screen and (max-width: 1024.9px)': {
      flexDirection: 'column'
    },
    '@media screen and (min-width: 1024.9px)': {
      flexDirection: 'column'
    },
    display: 'flex',
    gap: '16px'
  };
});